import {} from '@vanilla-extract/css';

import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { ActivityLayout, ActivityNavigation } from '@blocks';
import { LiveAnalysis } from '@screens';
import { activityIdAtom } from '@store';
import { Box } from '@ui';

import { Navigation } from '../components/Navigation/Navigation';
import { LINKS } from '../utils/routes';

import * as css from './screens.css';

export const LiveAnalysisScreen = () => {
    const navigate = useNavigate();
    const activityId = useAtomValue(activityIdAtom);

    return (
        <ActivityLayout getActivities={LINKS.getActivities}>
            <Navigation isActivity />
            <Box className={css.layout}>
                <ActivityNavigation
                    onSelectActive={(swingId) => navigate(LINKS.getFullActivity(activityId, swingId))}
                    onNavigateToLiveAnalysis={() => navigate(LINKS.getLiveAnalysis())}
                    isLiveAnalysis
                />
                <Box flex={1}>
                    <LiveAnalysis />
                </Box>
            </Box>
        </ActivityLayout>
    );
};
